export default __webpack_public_path__ + "static/media/headerimg.c1e3f92d.png";